var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-backtop',{attrs:{"bottom":100}},[_c('div',{staticClass:"back-box back-top flexcolumn"},[_c('div',{staticClass:"back-item flexcolumn flexcenter"},[_c('div',{staticClass:"back-item-icon"},[_c('i',{staticClass:"iconfont icon-zhiding"})]),_c('div',{staticClass:"back-item-text"},[_vm._v("返回顶部")])])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }